"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.I = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.I = styled_components_1.default.span `
  font-style: italic;
`;
//# sourceMappingURL=italic-text.js.map